import React from 'react';
import { Search } from 'lucide-react';
import { useCollaborations } from '../context/CollaborationsContext';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { cn } from '../lib/utils';

export default function Toolbar({ columns, onColumnsChange }) {
  const { searchQuery, setSearchQuery } = useCollaborations();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder="Buscar influencer..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-9"
        />
      </div>

      <div className="inline-flex items-center rounded-md border bg-card shadow-[0_1px_4px_rgba(15,23,42,0.04)] p-1 shrink-0">
        {[1, 2, 3, 4].map((n) => (
          <Button
            key={n}
            type="button"
            variant="ghost"
            size="sm"
            onClick={() => onColumnsChange(n)}
            title={`${n} columna${n > 1 ? 's' : ''}`}
            className={cn(
              'h-7 w-7 px-0 text-xs',
              columns === n && 'bg-accent text-accent-foreground',
            )}
          >
            {n}
          </Button>
        ))}
      </div>
    </div>
  );
}
